import { observer } from "mobx-react";
import { Box, Typography, Grid, Tab, TextField } from "@material-ui/core";
import { Button } from "@roc/ui";
import { useEffect, useState } from "react";
import { useStore } from "@roc/client-portal-shared/hooks";

export const PhoneCallCadenceStep = observer(({stepToEdit}) => {
  const { cadenceStore } = useStore();
  const { cadenceForm } = cadenceStore;
  const handleInstructionsChange = (value) => {
     cadenceForm.onFieldChange('content',value);
  };

  const setupTextEdition = () => {
    cadenceForm.onFieldChange('content', stepToEdit.stepContent.content || '');
  }

  useEffect(() => {
    if (stepToEdit?.stepContent) {
      setupTextEdition();
    } else {
      cadenceForm.reset();
    }
  }, [stepToEdit]);

  return (
    <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5">Notes</Typography>
          <TextField
            variant="outlined"
            fullWidth
            multiline={true}
            minRows={10}
            value={cadenceForm?.form?.fields?.content?.value}
            onChange={(e) => handleInstructionsChange(e.target.value)}
          />
        </Grid>
    </Grid>

  );
});
